import axios from "axios";
import store from "../store";

let instanceAxios = axios.create();

instanceAxios.interceptors.request.use(
  function (config) {
    store.commit("general/showLoading", true);
    if (store.getters["auth/loggedIn"]) {
      config.headers.authorization =
        store.state.auth.token_type + " " + store.state.auth.access_token;
    }
    config.timeout = 10000;
    if (config.responseType != "json") {
      config.responseType = config.responseType;
    } else {
      config.responseType = "json"; // Valor predeterminado si no se proporciona un parámetro válido
    }
    config.responseEncoding = "utf8";
    return config;
  },
  function (error) {
    store.commit("general/showLoading", false);
    return Promise.reject(error);
  }
);

instanceAxios.interceptors.response.use(
  function (response) {
    //store.commit("general/showLoading", false);
    return response.data;
  },
  function (error) {
    //store.commit("general/showLoading", false);
    return Promise.reject(error);
  }
);
export default instanceAxios;
